<template>
  <v-row align="center" justify="center" class="pb-8">
    <v-col class="text-center px-5 py-3" cols="12" sm="6" md="4">
      <div class="mb-6">
        <v-btn
          icon
          title="Autenticación"
          aria-label="Autenticación"
          @click="goToToken"
        >
          <v-icon 
            size="60"
          >
            fas fa-user-circle</v-icon>
        </v-btn>
      </div>
      <span class="font-weight-bold leading--text" style="font-size: 32px"
        >Autenticación</span
      >

      <div class="mt-5">
        <v-form ref="form" v-model="valid">
          <v-col class="text-left pb-0">
            <span class="font-weight-bold">Nombre</span>
              <!-- outlined -->
            <v-text-field
              v-model="payload.usuario"
              placeholder="Ingrese un email válido"
              :rules="[rules.required, rules.email]"
              required
              class="mt-2"
            ></v-text-field>
          </v-col>
          <v-col class="text-left py-0">
            <span class="font-weight-bold elevation-0">Contraseña</span>
              <!-- outlined -->
            <v-text-field
              v-model="payload.password"
              required
              :append-icon="show1 ? 'far fa-eye' : 'far fa-eye-slash'"
              :rules="[rules.required]"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              class="mt-2"
            ></v-text-field>
          </v-col>
        </v-form>
        <div class="mt-5">
          <v-btn
            color="primary"
            @click="signin"
            :disabled="!valid"
            :loading="loading"
            class="mx-2 font-weight-bold"
            width="200"
            aria-label="Iniciar sesión"
            >Aceptar</v-btn
          >
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import axios from "@/config/axios";
import jwt_decode from "jwt-decode";


export default {
  data: () => ({
    loading: false,
    valid: true,
    rules: {
      required: (value) => !!value || "*Campo de texto requerido.",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Ingrese un email válido.";
      },
      emailMatch: () => "The email and password you entered don't match",
    },
    show1: false,
    payload: {
      usuario: "",
      password: "",
    },
    status: {
      loading: false,
      error: false,
      message: "",
    },
  }),
  methods: {
    async signin() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        await axios
          .post(
            `/Login`,
            this.payload
          )
          .then((res) => {
            let user = jwt_decode(res.data.token);
            user.jwt = res.data.token;

            this.$store.commit("auth/SET_AUTH_USER", user);
            this.$router.push("/Procesos/Index");
          })
          .catch((err) => {
            // // // // console.log(e)
            // // // this.$store.dispatch("process/showNotifier", {
            // // //   message: err,
            // // //   type: "error",
            // // // });

            if (err.response) {
              const error = new Error(err.response.data.Message);
              error.statusCode = err.response.data.StatusCode;

              this.$store.dispatch("process/showNotifier", {
                message: err.response.data.Message,
                type: err.response.data.StatusCode==500 ? "error" : "warning",
              });
              return
            }
            this.$store.dispatch("process/showNotifier", {
              message: err,
              type: "error",
            });

          })
          .finally((this.loading = false));
      }
    },
    goToToken(){
      this.$router.push("/login/token");      
    }
  },
};
</script>
<style scoped>
>>> .v-messages {
  margin-left: -8px !important;
}

>>> .v-icon.v-icon {
  font-size: 13px;
}
</style>
